import {SetStateAction} from "react";

export function WelcomePageTab(props: {
    showWelcomePage: boolean,
    setShowWelcomePage: SetStateAction<any>,
    taglineText: string,
    setTaglineText: SetStateAction<any>,
}) {
    return <div className="panel panel-default">
        <div className="panel-heading">
            <h3 className="panel-title text-center">Welcome Page</h3>
        </div>
        <div className="panel-body">
            <div className="row">
                <div className="col-lg-12">
                    The "Welcome Page" enables you to enhance your brand's identity by showing a full-screen image
                    or video.  Learn more about this feature <a href="https://docs.google.com/document/d/1nSd0zi9b1ST6ntdwYoptgjIYZh9QP7N7EpTXlh-qYM0/edit?usp=sharing"
                                                                target="_blank" rel="nofollow noopener noreferrer">here</a>.
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <input title="Enable Welcome Page" type="checkbox"
                           className="checkbox-default-links"
                           checked={props.showWelcomePage}
                           onChange={() => props.setShowWelcomePage(v => !v)}
                    />
                    &nbsp;<label>Enable Welcome Page</label>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-4">
                    <label>Tagline</label>
                    &nbsp;(Appears below the organization name)
                </div>
                <div className="col-sm-8">
                    <textarea title="Organization Tagline" rows={8}
                              placeholder="Include a sentence or two about your organization"
                              onChange={e => props.setTaglineText(e.target.value)} value={props.taglineText} />
                </div>
            </div>
        </div>
    </div>
}